import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';
import { MewsTeam, RouteType } from '@mews/enums';
import { FilterSidebarLayout, PageHeaderActionElement } from '@mews-commander/ui';
import { useCustomerDetailPage } from '@mews-commander/modules/src/modules/customerDetail';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Customer/$id/_sidebarLayout')({
    component: Component,
    staticData: {
        owner: MewsTeam.Accounts,
        type: RouteType.Frontend,
    },
});

function Component() {
    const { id } = Route.useParams();

    const { tabs, fullName, icons } = useCustomerDetailPage(id);

    return (
        <FilterSidebarLayout
            pageTitle={fullName}
            tabs={tabs}
            filterSchema={z.object({})}
            filterSidebar={{ title: '', fields: [] }}
            defaultFilterValues=""
            filterSidebarOpenedByDefault={false}
            actions={<PageHeaderActionElement />}
            titleSuffixSlot={icons}
        >
            <Outlet />
        </FilterSidebarLayout>
    );
}
